import { render, staticRenderFns } from "./SafeQuession.vue?vue&type=template&id=59347227&"
import script from "./SafeQuession.vue?vue&type=script&lang=js&"
export * from "./SafeQuession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports